<template>
  <div>
    <el-card
      shadow="always"
      style="box-shadow:none;border-radius: 5px;border: none;"
    >
      <el-form
        ref="form"
        size="small"
        :model="formData"
        :rules="rules"
        :disabled="disabled"
      >
        <div>
          <div class="d-flex">
            <div class="descriptions-item__label br-none">
              {{ $l('form_label_amzPriceControlNo') || '控价表编号' }}
            </div>
            <div class="descriptions-item__value flex-1">
              {{ formData.amzPriceControlNo || '新增控件表' }}
            </div>
            <div class="descriptions-item__label br-none bl-none">
              {{ $l('INDEX.Status') || '状态' }}
            </div>
            <div class="descriptions-item__value">
              <el-tag
                size="small"
                :type="
                  formData.amzPriceControlStatus === 'Y'
                    ? 'success'
                    : formData.amzPriceControlStatus === 'D'
                    ? 'danger'
                    : 'primary'
                "
              >
                {{ formData.v_amzPriceControlStatus || 'New' }}
              </el-tag>
            </div>
            <div class="descriptions-item__label br-none  bl-none">
              {{ $l('INDEX.table_label_modified_by') || '修改人' }}
            </div>
            <div class="descriptions-item__value flex-1">
              {{ formData.modifyByName }}
            </div>
            <div class="descriptions-item__label br-none  bl-none">
              {{ $l('table_label_modifyTime') || '更新时间' }}
            </div>
            <div class="descriptions-item__value flex-1">
              {{ formData.modifyTime }}
            </div>
          </div>

          <div class="d-flex">
            <div class="descriptions-item__label br-none">
              {{ $l('table_label_amzPriceControlName') || '控价表名称' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="amzPriceControlName">
                <el-input
                  v-model="formData.amzPriceControlName"
                  :placeholder="
                    $l('INDEX.tips_input_placeholder') || '请输入...'
                  "
                  maxlength="100"
                  clearable
                  size="mini"
                  style="width: 100%"
                  v-if="!disabled && !isConfirmEdit"
                ></el-input>
                <span v-else>
                  {{ formData.amzPriceControlName }}
                </span>
              </el-form-item>
            </div>

            <div class="descriptions-item__label br-none bl-none">
              {{ $l('form_label_useYear') || '适用年份' }}
            </div>
            <div class="descriptions-item__value w-150">
              <el-form-item prop="useYear">
                <el-date-picker
                  v-model="formData.useYear"
                  v-if="!disabled && !isConfirmEdit"
                  size="mini"
                  type="year"
                  style="width: 100%"
                  value-format="yyyy"
                  :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                >
                </el-date-picker>
                <span v-else>
                  {{ formData.useYear }}
                </span>
              </el-form-item>
            </div>

            <div class="descriptions-item__label br-none  bl-none">
              {{ $l('tabel_label_categoryCode') || '品类' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="categoryCode">
                <el-cascader
                  v-if="!disabled && !isConfirmEdit"
                  :options="categoryTree"
                  size="mini"
                  :props="{
                    emitPath: false,
                    checkStrictly: false,
                    value: 'value',
                    label: 'label',
                  }"
                  ref="cascaderCategoryTreeRef"
                  v-model="formData.categoryCode"
                  clearable
                  filterable
                  style="width: 100%"
                  :showAllLevels="false"
                >
                  <template slot-scope="{ node, data }">
                    <span>{{ data.label }}</span>
                    <span v-if="!node.isLeaf">
                      ({{ data.children.length }})
                    </span>
                  </template>
                </el-cascader>
                <span v-else>
                  {{ formData.categoryFullName }}
                </span>
              </el-form-item>
            </div>
          </div>

          <div class="d-flex bb-1">
            <div class="descriptions-item__label br-none">
              {{ $l('form_label_designCode') || '企划' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="designCode">
                <dict-select
                  v-model="formData.designCode"
                  url="/master/common/dict/baseUserSelect"
                  :selectedLabel.sync="formData.designName"
                  v-if="!disabled"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
                <span v-else>
                  {{ formData.designName }}
                </span>
              </el-form-item>
            </div>

            <div class="descriptions-item__label br-none bl-none">
              {{ $l('form_label_buyerCode') || '采购' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="buyerCode">
                <dict-select
                  v-model="formData.buyerCode"
                  url="/master/common/dict/baseUserSelect"
                  :selectedLabel.sync="formData.buyerName"
                  v-if="!disabled"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
                <span v-else>
                  {{ formData.buyerName }}
                </span>
              </el-form-item>
            </div>

            <div class="descriptions-item__label br-none bl-none">
              {{ $l('form_label_operateCode') || '运营' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="operateCode">
                <dict-select
                  v-model="formData.operateCode"
                  url="/master/common/dict/baseUserSelect"
                  :selectedLabel.sync="formData.operateName"
                  v-if="!disabled"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
                <span v-else>
                  {{ formData.operateName }}
                </span>
              </el-form-item>
            </div>

            <div class="descriptions-item__label br-none bl-none">
              {{ $l('form_label_logisticCode') || '物流' }}
            </div>
            <div class="descriptions-item__value flex-1">
              <el-form-item prop="logisticCode">
                <dict-select
                  v-model="formData.logisticCode"
                  url="/master/common/dict/baseUserSelect"
                  :selectedLabel.sync="formData.logisticName"
                  v-if="!disabled"
                  clearable
                  filterable
                  size="mini"
                  style="width:100%"
                ></dict-select>
                <span v-else>
                  {{ formData.logisticName }}
                </span>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <div class="d-flex justify-content-end mt-2">
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="save()"
          >{{ $l('INDEX.btn_save') || '保存' }}</el-button
        >
      </div>
    </el-card>
    <el-card
      shadow="always"
      style="box-shadow:none;border-radius: 5px;border: none;"
      class="mt-2"
    >
      <div class="d-flex mb-3">
        <div class="mr-2 title">
          {{ $l('title_control_product') || '控价表产品' }}
        </div>
        <el-button
          size="mini"
          plain
          class="add-p-b"
          v-if="!disabled"
          @click="onAddProduct"
          >{{ $l('button_add_product') || '添加产品' }}</el-button
        >
      </div>
      <div
        v-for="item in priceProductList"
        :key="item.amzPriceControlDetailCode"
      >
        <ControlProduct
          :disabled="disabled"
          :item="item"
          :isConfirmEdit="isConfirmEdit"
          :amzPriceControlCode="amzPriceControlCode"
          @reload="getContrilProduct"
        ></ControlProduct>
      </div>
    </el-card>
    <AddProduct
      v-if="showAddProduct"
      :amzPriceControlCode="amzPriceControlCode"
      :disabled="disabled"
      @close="onCloseAddProduct"
      @reload="getContrilProduct"
    ></AddProduct>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
import EditLoading from '@/mixins/edit-loading'
import ControlProduct from './ControlProduct.vue'
import AddProduct from './AddProduct.vue'

export default {
  mixins: [EditLoading],
  components: { ControlProduct, AddProduct },
  props: {
    disabled: { type: Boolean, default: false },
    isConfirmEdit: { type: Boolean, default: false },
    amzPriceControlCode: { type: String, default: '' },
  },
  data() {
    return {
      regionParams: { dictType: 'region' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      categoryTree: [],
      priceProductList: [],
      showAddProduct: false,
      formData: {
        commissionRate: 0,
        storageUnitPrice: 0,
        shipUnitPrice: 0,
        tariffsRate: 0,
        refundTaxRate: 0,
        vatRate: 0,
        truckingFee: 0,
        freightFee: 0,
      },
      rules: {
        amzPriceControlName: [
          {
            required: true,
            message: ' ',
          },
        ],
        useYear: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        categoryCode: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        designCode: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        operateCode: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
        logisticCode: [
          {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
        ],
      },
      backDialogVisible: false,
    }
  },
  mounted() {
    this.getTreeData()
    this.getData()
    this.getContrilProduct()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    onAddProduct() {
      if (!this.amzPriceControlCode) {
        this.$message.warning(
          this.$l('tips_pls_save_base_info') || '请先保存主信息!'
        )
        return
      }
      this.showAddProduct = true
    },
    onCloseAddProduct() {
      this.showAddProduct = false
    },
    getContrilProduct() {
      this.$api
        .ecomAmzPriceControlDetailListApi({
          amzPriceControlCode: this.amzPriceControlCode,
        })
        .then((res) => {
          this.priceProductList = res?.body?.data || []
        })
    },
    getTreeData() {
      this.$api
        .ecomAmzSpuCategoryApi({ parentCode: 'ABSHome' })
        .then((res) => {
          this.categoryTree = res.body.data || []
        })
        .catch(() => {})
    },
    async getData() {
      if (!this.amzPriceControlCode) return
      const res = await this.$api
        .ecomAmzPriceControlDetailApi({
          amzPriceControlCode: this.amzPriceControlCode,
        })
        .catch(() => null)
      this.formData = res?.body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .ecomAmzPriceControlSaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      if (this.formData.amzPriceControlCode) {
        this.getData()
      } else {
        const { amzPriceControlCode, amzPriceControlNo } = res.body
        // await this.closeCurPage()
        this.$router.replace({
          name: 'ecom-base-amzPriceControl-detail',
          params: { pageType: 'edit', amzPriceControlCode },
          query: { amzPriceControlNo },
        })
      }
    },
    async closeCurPage() {
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
.title {
  height: 25px;
  line-height: 25px;
  font-size: 18px;
  color: #101010;
  font-weight: 600;
}
.add-p-b {
  border-radius: 4px !important;
}
::v-deep {
  .el-form-item {
    margin-bottom: 0 !important;
    width: 100%;
  }
  .el-form-item__content {
    line-height: 1 !important;
  }
}
.flex-1 {
  flex: 1;
}
.bl-none {
  border-left: none !important;
}
.br-none {
  border-right: none !important;
}
.bb-1 {
  border-bottom: 1px solid #ebeef5;
}
.descriptions-item__label {
  border: 1px solid #ebeef5;
  padding: 8px 10px;
  width: 100px;
  min-width: 100px;
  font-size: 12px;
  height: 40px;
  box-sizing: border-box;
  text-align: left;
  font-weight: 400;
  line-height: 1.5;
  color: #909399;
  background: #fafafa;
  border-bottom: none;
}
.descriptions-item__value {
  padding: 8px 10px;
  height: 40px;
  min-width: 100px;
  border: 1px solid #ebeef5;
  font-size: 12px;
  color: #606266;
  display: flex;
  align-items: center;
  border-bottom: none !important;
}
.w-115 {
  width: 115px !important;
}
.w-150{
  width: 150px !important;
}
</style>
